export default __webpack_public_path__ + "static/media/ExpressWorkout.e39b005d.png";